<template>
  <div v-loading="loading">
    <WfCaseShell
      :title="'委托审核 · ' + xmbh"
      :show-save="false"
      :show-submit="canAudit"
      :show-back="canAudit"
      :submitting="acting"
      :backing="acting"
      @submit="doAudit(true)"
      @back="doAudit(false)"
    >
      <template slot="extra-actions">
        <button type="button" class="btn btn-default hidden-xs" @click="$router.push('/routine/' + encodeURIComponent(xmbh))">
          查看委托
        </button>
      </template>

      <div class="panel panel-default" v-if="project">
        <div class="panel-heading">任务信息</div>
        <div class="panel-body">
          <div class="form-horizontal">
            <div class="form-group">
              <label class="col-md-2 control-label">任务名称</label>
              <div class="col-md-4"><p class="form-control-static">{{ project.xmmc }}</p></div>
              <label class="col-md-2 control-label">委托单位</label>
              <div class="col-md-4"><p class="form-control-static">{{ project.wtdw_mc }}</p></div>
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">监测类型</label>
              <div class="col-md-4"><p class="form-control-static">{{ project.jclx }}</p></div>
              <label class="col-md-2 control-label">方案日期</label>
              <div class="col-md-4"><p class="form-control-static">{{ schemeDateDisplay }}</p></div>
            </div>
            <div class="form-group">
              <label class="col-md-2 control-label">委托日期</label>
              <div class="col-md-4"><p class="form-control-static">{{ project.entrust_date || '—' }}</p></div>
              <label class="col-md-2 control-label">状态</label>
              <div class="col-md-4"><p class="form-control-static">{{ project.xmzt }}</p></div>
            </div>
          </div>
        </div>
      </div>

      <div class="panel panel-default">
        <div class="panel-heading">监测详细信息</div>
        <div class="panel-body" style="padding:0">
          <table class="table table-bordered table-condensed" style="margin:0">
            <thead>
              <tr>
                <th>监测点位</th>
                <th>监测项目</th>
                <th>频次</th>
                <th>12月</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, i) in items" :key="i">
                <td>{{ row.monitor_place }}</td>
                <td>{{ row.item_names }}</td>
                <td>{{ freqLabel(row) }}</td>
                <td>{{ scheduleSummary(row) }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="panel panel-default" v-if="canAudit">
        <div class="panel-heading">审核意见</div>
        <div class="panel-body">
          <textarea class="form-control" rows="3" v-model="remark" />
          <p class="help-block" style="margin-top:8px">顶栏「提交」= 通过，顶栏「退回」= 退回。</p>
        </div>
      </div>
      <div v-else-if="project" class="alert alert-info">当前状态不可审核或您无权限</div>
    </WfCaseShell>
  </div>
</template>

<script>
import api from '@/utils/api'
import { deriveSchemeDate } from '@/utils/schemeDate'
import WfCaseShell from '@/components/ivan/WfCaseShell.vue'

export default {
  name: 'EntrustAudit',
  components: { WfCaseShell },
  data() {
    return {
      loading: false,
      acting: false,
      xmbh: '',
      project: null,
      items: [],
      remark: ''
    }
  },
  computed: {
    canAudit() {
      return this.project && this.project.xmzt === 'pending_audit'
    },
    schemeDateDisplay() {
      if (!this.project) return '—'
      return deriveSchemeDate(this.project.routine_year, this.project.entrust_date)
    }
  },
  watch: {
    '$route.params.xmbh': { immediate: true, handler(v) { if (v) { this.xmbh = v; this.load() } } }
  },
  methods: {
    freqLabel(row) {
      return `${row.freq_count || 1}次/期, 共${row.periods_count || 1}期${row.freq_label ? '(' + row.freq_label + ')' : ''}`
    },
    scheduleSummary(row) {
      if (!row.schedule_json) return '—'
      let obj = row.schedule_json
      if (typeof obj === 'string') { try { obj = JSON.parse(obj) } catch (e) { return '—' } }
      const m = []
      for (let i = 1; i <= 12; i++) if (obj[String(i)]) m.push(i)
      return m.length ? m.join(',') + '月' : '—'
    },
    async load() {
      this.loading = true
      try {
        const res = await api.get('yn_entrust_get', { xmbh: this.xmbh })
        if (res.data && res.data.error) {
          this.$message.error(res.data.error)
          return
        }
        this.project = res.data.project
        this.items = res.data.items || []
      } finally { this.loading = false }
    },
    async doAudit(pass) {
      this.acting = true
      try {
        const res = await api.postJson('yn_routine_audit', {
          xmbh: this.xmbh,
          pass: !!pass,
          remark: this.remark
        })
        if (res.data && res.data.error) {
          this.$message.error(res.data.error)
          return
        }
        this.$message.success(pass ? '审核通过' : '已退回')
        if (pass) {
          this.$router.push('/routine/plan/' + encodeURIComponent(this.xmbh))
        } else {
          await this.load()
        }
      } finally { this.acting = false }
    }
  }
}
</script>
